import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex)

export default new Vuex.Store({

  strict: true,

  state: {

    kliniken: [
      {
        id: 1,
        titel: "Klinik für Anästhesiologie Intensivmedizin und Schmerztherapie",
        emails: [
            {titel: "", adresse: "Anaesthesiologie@ukffm.de"},
        ],
        abteilungen: [
          {
            id: 1,
            titel: "Schmerztherapie",
            terminvergabe: "<a href='tel:06963014870'>069 6301-4870</a>",
            aufnahme: "<a href='tel:06963013301'>069 6301-3301</a>",
            betriebszeiten: "Mo.-Do. 08:00 bis 14:30 Uhr Freitags 08:00 bis 14:00 Uhr"
          },
          {
            id: 2,
            titel: "Prämedikation-Ambulanz",
            terminvergabe: "<a href='tel:069630183366'>069 6301-83366</a>",
            betriebszeiten: "Mo.-Fr. 08:00 bis 16:00 Uhr"
          }],
      },
      {
        id: 2,
        titel: "Zentrum der Chirurgie",
        abteilungen: [
          {
            id: 3,
            titel: "Allgemein-und Viszeralchirurgie und Onkologie",
            terminvergabe: "<a href='tel:06963017576'>069 6301-7576</a> und Onkologie <a href='tel:06963016682'>-6682</a>",
            aufnahme: "<a href='tel:06963013303'>069 6301-3303</a>",
            zusatzFelder: [
              {key: "E-Mail", value: "<a href='mailto:Allgemeinchirurgie@ukffm.de'>Allgemeinchirurgie@ukffm.de</a>"},
            ],
            betriebszeiten: "Mo.-Fr. 08:00 bis 15:00 Uhr"
          },
          {
            id: 4,
            titel: "Allgemein-und Viszeralchirurgie Lebertransplanation (LTX)",
            terminvergabe: "<a href='tel:06963017642'>069 6301-7642</a>",
            betriebszeiten: "Arzt: Transplant.-Zentrale"
          },
          {
            id: 5,
            titel: "Gefäß- und Endovascularchirurgie",
            terminvergabe: "<a href='tel:06963015349'>069 6301-5349</a>",
            aufnahme: "<a href='tel:06963013304'>069 6301-3304</a>",
            zusatzFelder: [
              {key: "E-Mail", value: "<a href='mailto:Gefaesschirurgie@ukffm.de'>Gefaesschirurgie@ukffm.de</a>"},
            ],
            betriebszeiten: "Mo.-Fr. 08:00 bis 16:00 Uhr"
          },
          {
            id: 6,
            titel: "Klinik für Kinderchirurgie und Kinderurologie",
            terminvergabe: "<a href='tel:06963016659'>069 6301-6659</a>",
            zusatzFelder: [
              {key: "E-Mail", value: "<a href='mailto:kinderchirurgie@ukffm.de'>kinderchirurgie@ukffm.de</a><br><a href='mailto:kinderurologie@ukffm.de'>kinderurologie@ukffm.de</a>"},
            ],
          },
          {
            id: 7,
            titel: "Mund-, Kiefer- und plastische Gesichtschirurgie",
            terminvergabe: "<a href='tel:069630183097'>069 6301-83097</a>",
            aufnahme: "<a href='tel:06963013306'>069 6301-3306</a>",
            zusatzFelder: [
              {key: "E-Mail", value: "<a href='mailto:MKPG@ukffm.de'>MKPG@ukffm.de</a>"},
            ],
            betriebszeiten: "Mo.-Fr. 08:00 bis 15:30 Uhr"
          },
          {
            id: 8,
            titel: "Thorax Chirurgie",
            terminvergabe: "<a href='tel:069630185448'>069 6301-85448</a>",
            aufnahme: "<a href='tel:06963013307'>069 6301-3307</a>",
            betriebszeiten: "Mo.-Fr. 08:00 bis 16:00 Uhr"
          },
          {
            id: 9,
            titel: "Herz- und thorakale Gefäßchirurgie",
            terminvergabe: "<a href='tel:069630183316'>069 6301-83316</a>",
            zusatzFelder: [
              {key: "E-Mail", value: "<a href='mailto:Herzchirurgie@ukffm.de'>Herzchirurgie@ukffm.de</a>"},
            ],
            betriebszeiten: "Mo.-Fr. 08:00 bis 16:00 Uhr"
          },
          {
            id: 10,
            titel: "Unfall-, Hand- und Wiederherstellungschirurgie",
            terminvergabe: "<a href='tel:06963015069'>069 6301-5069</a> Privat <a href='tel:06963016123'>6123</a>",
            aufnahme: "<a href='tel:06963013308'>069 6301-3308</a>",
            zusatzFelder: [
              {key: "E-Mail", value: "<a href='mailto:Unfallchirurgie@ukffm.de'>Unfallchirurgie@ukffm.de</a>"},
            ],
            betriebszeiten: "Mo.-Fr, 08:00 bis 16:00 Uhr"
          },
          {
            id: 11,
            titel: "Klinik für Orthopädie (Friedrichsheim)",
            zusatzFelder: [
              {key: "E-Mail", value: "<a href='mailto:Orthopaedie@ukffm.de'>Orthopaedie@ukffm.de</a>"},
              {key: "Terminvergabe Kinder (0-17 Jahre)", value: "<a href='tel:069630194206'>069 6301-94206</a>"},
              {key: "Betriebszeiten", value: "Mo.-Fr. 08:00-12:00 Uhr"},
              {key: "Terminvergabe Erwachsene", value: "<a href='tel:069630194388'>069 6301-94388</a>"},
              {key: "Betriebszeiten&nbsp;", value: "Mo.-Fr. 08:00-16:00 Uhr"},
            ],
          },
          {
            id: 12,
            titel: "Urologie für Erwachsene",
            zusatzFelder: [
              {key: "Chefarztsekretariat", value: "<a href='tel:06963015352'>Tel. 069 6301-5352</a>"},
              {key: "", value: "Fax 069&nbsp;6301-6464"},
              {key: "Sekretariat", value: "<a href='tel:06963015865'>Tel. 069 6301-5865</a>"},
              {key: "", value: "Fax 069&nbsp;6301-87143"},
              {key: "Terminvergabe", value: "<a href='tel:06963015155'>Tel. 069 6301-5155</a>"},
              {key: "", value: "Fax 069&nbsp;6301-87143"},
              {key: "OP Management", value: "<a href='tel:06963016442'>Tel. 069 6301-6442</a>"},
              {key: "", value: "Fax 069&nbsp;6301-3938"},
            ],
            betriebszeiten: "Mo.-Fr. 08:00 bis 15:00 Uhr"
          },
          {
            id: 13,
            titel: "Wundzentrum",
            terminvergabe: "<a href='tel:06963017103'>069 6301-7103</a>",
            betriebszeiten: "Mo.-Fr. 08:00 bis 16:00 Uhr"
          },
          {
            id: 14,
            titel: "Physikal. Therapie Zchir Unfallnachbeh",
            terminvergabe: "<a href='tel:06963017215'>069 6301-7215</a>"
          }],
      },
      {
        id: 3,
        titel: "Klinik für Dermatologie, Venerologie und Allergologie",
        abteilungen: [
          {
            id: 15,
            titel: "Dermatologie (außer Mittwochs)",
            terminvergabe: "<a href='tel:06963015118'>069 6301-5118</a>/ Privat <a href='tel:06963015179'>-5179</a>",
            aufnahme: "<a href='tel:06963013310'>069 6301-3310</a>",
            zusatzFelder: [
              {key: "E-Mail", value: "<a href='mailto:Dermatologie@ukffm.de'>Dermatologie@ukffm.de</a>"},
            ],
            betriebszeiten: "Mo.-Fr. 09:00 bis 15:00 Uhr"
          },
          {
            id: 16,
            titel: "Venerologie und Allergologie/Allergie",
            terminvergabe: "<a href='tel:06963015705'>069 6301-5705</a>",
            zusatzFelder: [
              {key: "Fax", value: "069 6301-6559"}
            ],
            betriebszeiten: "Mo.-Fr. 08:00 bis 16:00 Uhr"
          },
          {
            id: 17,
            titel: "Andrologie",
            terminvergabe: "<a href='tel:06963016661'>069 6301-6661</a>",
            zusatzFelder: [
              {key: "Fax", value: "069 6301-81080"}
            ],
            betriebszeiten: "Mo.-Fr. 08:00 bis 16:00 Uhr"
          },
          {
            id: 18,
            titel: "&nbsp;",
            zusatzFelder: [
              {key: "Hochschulambulanz", value: "Fax 069 6301-6575"},
              {key: "Privatambulanz", value: "Fax 069 6301-5117"},
              {key: "Klinische Forschung", value: "Tel. <a href='tel:069630183115'>069 6301-83115</a>"},
              {key: "", value: "Fax 069 6301-83175"},
            ],
          }],
      },
      {
        id: 4,
        titel: "Klinik für Frauenheilkunde und Geburtshilfe",
        abteilungen: [
          {
            id: 19,
            titel: "Frauenheilkunden / Privat",
            terminvergabe: "<a href='tel:06963015176'>069 6301-5176</a>/ <a href='tel:06963015517'>-5517</a>",
            betriebszeiten: "Mo.-Fr. 08:00 bis 16:00 Uhr"
          },
          {
            id: 20,
            titel: "Geburtshilfe (Kreißsaal)",
            terminvergabe: "<a href='tel:06963015190'>069 6301-5190</a>",
            //aufnahme: "<a href='tel:06963013312'>069 6301-3312</a>",
            betriebszeiten: "Immer erreichbar"
          },
          {
            id: 21,
            titel: "Brustzentrum",
            terminvergabe: "<a href='tel:06963015119'>069 6301-5119</a>",
            betriebszeiten: "Mo.-Fr. 08:00 bis 16:00 Uhr"
          },
          {
            id: 22,
            titel: "UCT Psycho-Onkologie",
            terminvergabe: "<a href='tel:069630183734'>069 6301-83734</a>",
            betriebszeiten: "Vorträge Dienstags von 17:30 - 18:30"
          },
          {
            id: 23,
            titel: "Pränataldiagnostik",
            terminvergabe: "<a href='tel:06963016506'>069 6301-6506</a>"
          },
          {
            id: 24,
            titel: "Schwangerschaftsberatung",
            terminvergabe: "<a href='tel:06963015501'>069 6301-5501</a>",
            zusatzFelder: [
              {key: "Betriebszeiten", value: "werktags 08:00 bis 15:00 Uhr"},
            ],
          },
          {
            id: 245397042,
            titel: "Elterninformationsabend",
            sonstiges: "<span class='d-block text-start'>jeden zweiten und vierten Montag im Monat, 18:30 Uhr</span>",
          },
          {
            id: 25,
            titel: "Gynäkologische Endokrinologie und Kinderwunschzentrum",
            terminvergabe: "<a href='tel:06963015708'>069 6301-5708</a>",
            betriebszeiten: "Mo.-Fr. 08:00 bis 15:00 Uhr"
          },
          {
            id: 25468358,
            titel: "Homepage der Geburtsmedizin",
            sonstiges: "<a href='https://www.geburtunifrankfurt.de' target='_blank' class='d-block text-start'>www.geburtunifrankfurt.de</a>",
          }
        ],
      },
      {
        id: 5,
        titel: "Klinik für Augenheilkunde",
        abteilungen: [
          {
            id: 26,
            titel: "Augenheilkunde (Call-Center für alle Abt. innerhalb der ZAU)",
            zusatzFelder: [
              {key: "All. Patiententelefon, Terminvergabe gesetzl. Versicherte, Notfälle", value: "<a href='tel:06963015098'>069 6301-5098</a>"},
              {key: "Privatambulanz", value: "<a href='tel:06963015187'>069 6301-5187</a>/<a href='tel:06963015056'>-5056</a>"},
              {key: "Stationäre Aufnahme", value: "<a href='tel:06963015397'>069 6301-5397</a>"},
              {key: "Refraktive Chirurgie", value: "<a href='tel:06963015618'>069 6301-5618</a>"},
              {key: "Netzhaut- und Glaskörperchirurgie", value: "<a href='tel:06963015689'>069 6301-5689</a>"},
              {key: "Kinderaugenheilkunde und Schielbehandlung, Lid- und Tränenwegschirurgie", value: "<a href='tel:06963015721'>069 6301-5721</a>"},
            ],
            betriebszeiten: "Mo.-Fr. 08:00 bis 18:00 Uhr"
          }],
      },
      {
        id: 6,
        titel: "Klinik für Hals-Nasen-Ohrenheilkunde",
        abteilungen: [
          {
            id: 27,
            titel: "Hals-Nasen-Ohrenheilkunde",
            terminvergabe: "&nbsp;",
            zusatzFelder: [
              {key: "<span class='ps-3 d-block'>gesetzlich Versicherte</span>", value: "Tel. <a href='tel:06963013313'>069 6301-3313</a><br>E-Mail <a href='mailto:hno-info@ukffm.de'>hno-info@ukffm.de</a>"},
              {key: "<span class='ps-3 d-block'>privat Versicherte</span>", value: "Tel. <a href='tel:06963015163'>069 6301-5163</a><br>E-Mail <a href='mailto:hno-sekretariat@ukffm.de'>hno-sekretariat@ukffm.de</a>"},
              {key: "Anfrage Stationäre Aufnahme", value: "<a href='tel:06963013313'>069 6301-3313</a>"},
            ],
            betriebszeiten: "Mo.-Fr. 08:00 bis 16:00 Uhr"
          },
          {
            id: 291,
            titel: "Hörzentrum",
            terminvergabe: "Tel. <a href='tel:06963013726'>069 6301-3726</a><br>Fax 069&nbsp;6301-80089<br>E-Mail <a href='mailto:hoerzentrum@ukffm.de'>hoerzentrum@ukffm.de</a>",
          },
          {
            id: 28,
            titel: "Phoniatrie u. Pädaudiologie/ Kinder HNO",
            terminvergabe: "<a href='tel:06963015775'>069 6301-5775</a>"
          },
        ],
      },
      {
        id: 7,
        titel: "Zentrum der Radiologie",
        abteilungen: [
          {
            id: 30,
            titel: "Haus 23 Leitstelle / Anmeldung",
            terminvergabe: "<a href='tel:069630187200'>069 6301-87200</a> oder <a href='tel:069630187201'>-87201</a>",
            // zusatzFelder: [
            //   {key: "E-Mail", value: "<a href='mailto:Radiologie@ukffm.de'>Radiologie@ukffm.de</a>"},
            // ],
            betriebszeiten: "Mo.- Fr. 08:00 bis 17:00 Uhr"
          },
          {
            id: 31,
            titel: "Haus 23 + Haus 97-OUF Terminvergabe",
            terminvergabe: "<a href='tel:069630187202'>069 6301-87202</a>",
            betriebszeiten: "Mo.- Fr. 08:00 bis 16:00 Uhr"
          },
          {
            id: 32,
            titel: "Haus 23 CD / Befund Anforderung",
            terminvergabe: "<a href='tel:069630187253'>069 6301-87253</a>",
            betriebszeiten: "Mo. - Fr.08:00 bis 12:00 Uhr"
          },
          {
            id: 33,
            titel: "Haus 23 Sekretariat Prof. Vogl",
            terminvergabe: "<a href='tel:06963017277'>069 6301-7277</a> oder <a href='tel:06963017278'>-7278</a>",
            betriebszeiten: "Mo.- Fr. 08:00 bis 19:00 Uhr"
          },
          {
            id: 34,
            titel: "Haus 25B Kardiologie / MRT",
            terminvergabe: "<a href='tel:069630184491'>069 6301-84491</a>"
          },
          {
            id: 35,
            titel: "Haus 14 Knochendichtmessung und Mammographie Anmeldung",
            terminvergabe: "<a href='tel:06963015174'>069 6301-5174</a>",
            betriebszeiten: "Mo.- bis Fr. 08:00 bis 16:00 Uhr"
          },
          {
            id: 36,
            titel: "Strahlen Ambulanz Hs.15, 4. OG",
            aufnahme: "<a href='tel:06963013327'>069 6301-3327</a>",
            zusatzFelder: [
              {key: "Terminvergabe Hochschulambulanz", value: "<a href='tel:06963015914'>069 6301-5914</a>"},
              {key: "Privatambulanz", value: "<a href='tel:06963015130'>069 6301-5130</a>"},
            ],
            betriebszeiten: "Mo.-Fr. 08:00 bis 16:00 Uhr"
          },
          {
            id: 3667474,
            titel: "Strahlen Ambulanz Therapiebereich Hs. 14, UG",
            zusatzFelder: [
              {key: "Anmeldung für Patienten in der Therapie", value: "<a href='tel:06963016224'>069 6301-6224</a>"},
            ],
          },
          {
            id: 37,
            titel: "Nuklearmedizin HSA / PET-CT",
            terminvergabe: "<a href='tel:06963016783'>069 6301-6783</a> / <a href='tel:06963016782'>6782</a>",
            aufnahme: "<a href='tel:06963013326'>069 6301-3326</a>",
            betriebszeiten: "Mo.-Fr. 08:00 bis 16:00 Uhr"
          },
          {
            id: 38,
            titel: "Haus 32 Kinder-Radiologie",
            terminvergabe: "<a href='tel:06963015248'>069 6301-5248</a>",
            betriebszeiten: "Mo.- Mi. 08:00 bis 16:00, Do.- Fr. 08:00 bis 15:30 Uhr"
          },
          {
            id: 39,
            titel: "Haus 95 / Neuroradiologie",
            terminvergabe: "<a href='tel:06963015462'>069 6301-5462</a>",
            zusatzFelder: [
              {key: "E-Mail", value: "<a href='mailto:neuroradiologie@ukffm.de'>neuroradiologie@ukffm.de</a>"},
            ],
          },
          {
            id: 40,
            titel: "Brain Imaging Center(BIC)neben Haus 95",
            terminvergabe: "<a href='tel:069630183819'>069 6301-83819</a>"
          },
          {
            id: 41,
            titel: "Haus 97-OUF Terminvergabe",
            terminvergabe: "<a href='tel:069630187202'>069 6301-87202</a>",
            betriebszeiten: "Mo.- Fr. 08:00 bis 17:00 Uhr"
          }],
      },
      {
        id: 8,
        titel: "Universitäres Centrum für Tumorerkrankung (UCT)",
        abteilungen: [
          {
            id: 42,
            titel: "UCT",
            zusatzFelder: [
              {key: "Patientenhotline", value: "<a href='tel:069630187333'>069 6301-87333</a>"},
              {key: "Tagesklinik", value: "<a href='tel:06963017965'>069 6301-7965</a>"},
              {key: "Krebsberatungsstelle", value: "<a href='tel:069630186895'>069 6301-86895</a>"},
              {key: "Ambulanz für Palliativmedizin", value: "<a href='tel:069630186024'>069 6301-86024</a><br>Betriebszeiten: Mo.-Fr. 08:00 bis 16:00 Uhr"}
            ],
          },
        ],
      },
      {
        id: 9,
        titel: "Christiane Herzog / CF- Zentrum",
        abteilungen: [
          {
            id: 43,
            titel: "Mukoviszidose in Haus 18, EG",
            terminvergabe: "<a href='tel:06963014232'>069 6301-4232</a>"
          }],
      },
      {
        id: 10,
        titel: "Zentrum der Inneren Medizin",
        abteilungen: [
          {
            id: 44,
            titel: "Stationäre Aufnahme (MATE)",
            terminvergabe: "<a href='tel:06963013904'>069 6301-3904</a>",
            betriebszeiten: "Aufnahme Management"
          },
          {
            id: 45,
            titel: "Medizinische Klinik 1: Gastroenterologie",
            terminvergabe: "<a href='tel:06963015441'>069 6301-5441</a> / Privat <a href='tel:06963016899'>-6899</a>",
            aufnahme: "<a href='tel:06963013314'>069 6301-3314</a>",
            zusatzFelder: [
              {key: "E-Mail", value: "<a href='mailto:Med1-Ambulanzen@ukffm.de'>Med1-Ambulanzen@ukffm.de</a>"}
            ],
            betriebszeiten: "Mo.-Fr. 08:00 bis 15:00 Uhr"
          },
          {
            id: 46,
            titel: "Endoskopie ZIM",
            terminvergabe: "<a href='tel:06963015357'>069 6301-5357</a>",
            zusatzFelder: [
              {key: "E-Mail", value: "<a href='mailto:Med1-Ambulanzen@ukffm.de'>Med1-Ambulanzen@ukffm.de</a>"}
            ],
            betriebszeiten: "Mo.-Fr. 08:00 bis 15:00 Uhr"
          },
          {
            id: 47,
            titel: "Medizinische Klinik 1: Endokrinologie",
            terminvergabe: "<a href='tel:06963015293'>069 6301-5293</a> / Privat <a href='tel:06963015781'>-5781</a>",
            zusatzFelder: [
              {key: "E-Mail", value: "<a href='mailto:Med1-Ambulanzen@ukffm.de'>Med1-Ambulanzen@ukffm.de</a>"}
            ],
            betriebszeiten: "Mo.-Fr. 08:00 bis 15:00 Uhr"
          },
          {
            id: 48,
            titel: "Medizinische Klinik 1: Pneumologie Onkologie",
            terminvergabe: "<a href='tel:069630187269'>069 6301-87269</a>",
            zusatzFelder: [
              {key: "E-Mail", value: "<a href='mailto:Med1-Ambulanzen@ukffm.de'>Med1-Ambulanzen@ukffm.de</a>"}
            ],
            betriebszeiten: "Mo.-Fr. 08:00 bis 16:00 Uhr"
          },
          {
            id: 49,
            titel: "Medizinische Klinik 1: Gastrointestinale Onkologie",
            terminvergabe: "<a href='tel:06963016682'>069 6301-6682</a>",
            zusatzFelder: [
              {key: "E-Mail", value: "<a href='mailto:Med1-Ambulanzen@ukffm.de'>Med1-Ambulanzen@ukffm.de</a>"}
            ],
            betriebszeiten: "Mo.-Fr. 08:00 bis 16:00 Uhr"
          },
          {
            id: 50,
            titel: "Pneumologische Ambulanz Haus 23C",
            terminvergabe: "<a href='tel:06963014232'>069 6301-4232</a>",
            zusatzFelder: [
              {key: "E-Mail", value: "<a href='mailto:Med1-Ambulanzen@ukffm.de'>Med1-Ambulanzen@ukffm.de</a>"}
            ],
            betriebszeiten: "Mo.-Fr. 08:00 bis 16:00 Uhr"
          },
          {
            id: 51,
            titel: "Post-COVID-19 Ambulanz",
            terminvergabe: "<a href='tel:069630185607'>069 6301-85607</a>",
            betriebszeiten: "Di.-Fr. 09:00 bis 11:00 Uhr"
          },
          {
            id: 52,
            titel: "Medizinische Klinik 1 Ernährungsamb.",
            terminvergabe: "<a href='tel:06963015055'>069 6301-5055</a>",
            zusatzFelder: [
              {key: "E-Mail", value: "<a href='mailto:Med1-Ambulanzen@ukffm.de'>Med1-Ambulanzen@ukffm.de</a>"}
            ],
            betriebszeiten: "Mo.- Fr. 09:00 bis 12:00 Uhr"
          },
          {
            id: 53,
            titel: "Medizinische Klinik 1 Studienambulanz",
            terminvergabe: "<a href='tel:069630187769'>069 6301-87769</a>"
          },
          {
            id: 54,
            titel: "Die Medizinische Klinik 2 Hämatologie und Onkolgie",
            terminvergabe: "<a href='tel:06963015677'>069 6301-5677</a>",
            aufnahme: "<a href='tel:06963013315'>069 6301-3315</a>",
            zusatzFelder: [
              {key: "E-Mail", value: "<a href='mailto:Haematologie@ukffm.de'>Haematologie@ukffm.de</a>"},
            ],
            betriebszeiten: "Mo.-Fr. 08:00 bis 16:00 Uhr"
          },
          {
            id: 55,
            titel: "Die Medizinische Klinik 2 Allgemeine Infektiologie und Tropenmedizin",
            zusatzFelder: [
              {key: "Ambulanz", value: "<a href='tel:06963017680'>069 6301-7680</a>"},
              {key: "<span class='ps-3 d-block'>Betriebszeiten</span>", value: "09:00 – 14:00 Uhr"},
              {key: "Stationäre Aufnahme", value: "<a href='tel:069630184682'>069 6301-84682</a>"},
              {key: "<span class='ps-3 d-block'>Betriebszeiten</span>", value: "08:00 – 16.30 Uhr"},
              {key: "E-Mail", value: "<a href='mailto:Infektiologie@ukffm.de'>infektiologie@ukffm.de</a>"},
            ],
          },
          {
            id: 56,
            titel: "Die Medizinische Klinik 2 Rheumatologie",
            terminvergabe: "<a href='tel:06963017311'>069 6301-7311</a> / Privat <a href='tel:06963017301'>-7301</a>",
            zusatzFelder: [
              {key: "E-Mail", value: "<a href='mailto:Rheumatologie@ukffm.de'>Rheumatologie@ukffm.de</a>"},
            ],
            betriebszeiten: "Mo.-Fr. 08:00 bis 16:00 Uhr"
          },
          {
            id: 57,
            titel: "Medizinische Klinik 3 Kardiologie/Angiologie – Universitäres Herz-/Gefäßzentrum",
            sonstiges: "<span class='d-block text-start'>Alle Informationen zum Universitären Herz- und Gefäßzentrum Frankfurt finden Sie unter:<br><a href='https://www.herz-frankfurt.de'>www.herz-frankfurt.de</a></span>",
          },
          {
            id: 58,
            titel: "Medizinische Klinik 4 Nephrologie",
            zusatzFelder: [
              {key: "Sekretariat Prof. Speer", value: "Tel. <a href='tel:06963015555'>069 6301-5555</a> oder <a href='tel:06963015786'>-5786</a>"},
              {key: "", value: "Fax 069 6301-5451"},
              {key: "", value: "E-Mail <a href='mailto:nephrologie@ukffm.de'>nephrologie@ukffm.de</a>"},
              {key: "Terminvergabe Privatsprechstunde", value: "Tel. <a href='tel:06963015555'>069 6301-5555</a> oder <a href='tel:06963015786'>-5786</a>"},
              {key: "Terminvergabe Ambulanzen", value: "Tel. <a href='tel:06963015770'>069 6301-5770</a>"},
              {key: "Transplantationszentrum", value: "Tel. <a href='tel:06963014633'>069 6301-4633</a>"},
              {key: "", value: "Fax 069 638682"},
              {key: "Zuweisertelefon nur für Ärzte", value: "Tel. <a href='tel:015117192367'>0151 17 19 23 67</a>"},
            ],
            betriebszeiten: "Mo.-Fr. 08:00 bis 16:00 Uhr"
          },
          {
            id: 59,
            titel: "Gerinnungsambulanz",
            terminvergabe: "<a href='tel:06963015051'>069 6301-5051</a>",
            betriebszeiten: "Mo.-Fr. 08:00 bis 16:00 Uhr"
          },
          {
            id: 60,
            titel: "Lebertransplant.-Ambulanz (LTX)",
            terminvergabe: "<a href='tel:06963014739'>069 6301-4739</a>",
            zusatzFelder: [
              {key: "E-Mail", value: "<a href='mailto:Med1-Ambulanzen@ukffm.de'>Med1-Ambulanzen@ukffm.de</a>"}
            ],
          },
          {
            id: 61,
            titel: "Physikal. Therapie ZIM",
            terminvergabe: "<a href='tel:06963017345'>069 6301-7345</a>"
          },
          {
            id: 62,
            titel: "Knochenmarkstransplantation / KMT",
            terminvergabe: "<a href='tel:06963016103'>069 6301-6103</a>"
          },
        ],
      },
      {
        id: 1147,
        titel: "Institut für Medizinische Mikrobiologie und Krankenhaushygiene",
        abteilungen: [
          {
            id: 63246,
            titel: "Sekretariat Prof. Dr. Kempf",
            zusatzFelder: [
              {key: "Tel.", value: "<a href='tel:06963015019'>069 6301-5019</a>"},
              {key: "Fax", value: "069 6301-83431"},
              {key: "E-Mail", value: "<a href='mailto:manuela.mcgarry@ukffm.de'>manuela.mcgarry@ukffm.de</a>"},
            ],
          },
        ],
      },
      {
        id: 11,
        titel: "Institut für Virologie",
        abteilungen: [
          {
            id: 63,
            titel: "&nbsp;&nbsp;",
            zusatzFelder: [
              {key: "Sekretariat Prof. Ciesek", value: "Tel. <a href='tel:06963015219'>069 6301-5219</a><br>Fax 069&nbsp;6301-6477<br>E-Mail <a href='mailto:Virologie@ukffm.de'>Virologie@ukffm.de</a>"},
              {key: "Reisemedizinische Impfambulanz", value: "Tel. <a href='tel:06963015033'>069 6301-5033</a>"},
            ],
            betriebszeiten: "Mo. + Mi. 08:00-13:00 Uhr"
          }
        ],
      },
      {
        id: 12,
        titel: "Zentrum der Kinder- und Jugendmedizin",
        emails: [
          {titel: "Kinderpneumologie", adresse: "Kinderpneumologie@ukffm.de"},
          {titel: "Kinderneurologie", adresse: "Kinderneurologie@ukffm.de"},
        ],
        abteilungen: [
          {
            id: 64,
            titel: "Terminvereinbarung Telefonzentrale",
            terminvergabe: "<a href='tel:069630180400'>069 6301-80400</a>"
          },
          {
            id: 65,
            titel: "Klinik für Kinder und Jugendmedizin",
            aufnahme: "<a href='tel:06963013318'>069 6301-3318</a>",
            zusatzFelder: [
              {key: "Information", value: "<a href='tel:069630185888'>069 6301-85888</a>"}
            ],
          },
          {
            id: 66,
            titel: "Kindergerinnungsambulanz",
            terminvergabe: "<a href='tel:06963016432'>069 6301-6432</a>"
          },
          {
            id: 67,
            titel: "Hämatologie und Onkolgie",
            terminvergabe: "<a href='tel:06963015040'>069 6301-5040</a>",
            zusatzFelder: [
              {key: "E-Mail", value: "<a href='mailto:Kinderhaematologie@ukffm.de'>Kinderhaematologie@ukffm.de</a>"},
            ],
          },
          {
            id: 6767595731,
            titel: "Neonatologie",
            zusatzFelder: [
              {key: "Allgemeine Anfragen und Terminanfragen", value: "<a href='tel:06963014716'>069 6301-4716</a>"},
              {key: "E-Mail", value: "<a href='mailto:neonatologie@ukffm.de'>neonatologie@ukffm.de</a>"},
              {key: "E-Mail Leiter der Abteilung", value: "<a href='mailto:ulrich.rochwalsky@ukffm.de'>ulrich.rochwalsky@ukffm.de</a>"},
            ],
          },
        ],
      },
      {
        id: 12534757865,
        titel: "Hessisches Kindervorsorgezentrum am Universitätsklinikum Frankfurt",
        abteilungen: [
          {
            id: 675383,
            titel: "Leitung Prof. Dr. Matthias Kieslich",
            zusatzFelder: [
              {key: "Sekretariat", value: "<a href='tel:06963015560'>069 6301-5560</a>"},
              {key: "Nadja Müller", value: ""},
              {key: "Sohal Nawabi", value: ""},
              {key: "E-Mail", value: "<a href='mailto:kinderneurologie@ukffm.de'>kinderneurologie@ukffm.de</a>"},
            ],
          },
          {
            id: 6789437,
            titel: "Kindervorsorgeuntersuchungen (KVU)",
            zusatzFelder: [
              {key: "Bereichsleitung Ulrich Klein", value: "<a href='tel:069630187501'>069 6301-87501</a>"},
              {key: "E-Mail", value: "<a href='mailto:kvu@ukffm.de'>kvu@ukffm.de</a>"},
            ],
          },
          {
            id: 6783676739,
            titel: "Kindersprachscreening (KiSS)",
            zusatzFelder: [
              {key: "Bereichsleitung Nadine Eich", value: "<a href='tel:069630187800'>069 6301-87800</a>"},
              {key: "E-Mail", value: "<a href='mailto:kiss@ukffm.de'>kiss@ukffm.de</a>"},
            ],
          },
          {
            id: 67975784573,
            titel: "Neugeborenenhörscreening (NHS)",
            zusatzFelder: [
              {key: "Bereichsleitung Thomas Tischer", value: "<a href='tel:069630187801'>069 6301-87801</a>"},
              {key: "E-Mail", value: "<a href='mailto:nhs@ukffm.de'>nhs@ukffm.de</a>"},
            ],
          },
          {
            id: 677892035,
            titel: "Screening-Zentrum Hessen (SZH)",
            zusatzFelder: [
              {key: "Bereichsleitung PD Dr. Martin Lindner", value: "<a href='tel:069630180199'>069 6301-80199</a>"},
              {key: "E-Mail", value: "<a href='mailto:martin.lindner@ukffm.de'>martin.lindner@ukffm.de</a>"},
            ],
          },
          {
            id: 67,
            titel: "Transdisziplinäres Kinderschutzzentrum (TKSZ)",
            zusatzFelder: [
              {key: "Bereichsleitung Prof. Dr. Marco Baz Bartels", value: "<a href='tel:06963015976'>069 6301-5976</a>"},
              {key: "E-Mail", value: "<a href='mailto:kinderschutzambulanz@ukffm.de' style='white-space:nowrap;'>kinderschutzambulanz@ukffm.de</a>"},
            ],
          },
        ],
      },
      {
        id: 13,
        titel: "Childhood-Haus Frankfurt / Kinderschutzambulanz",
        abteilungen: [
          {
            id: 68,
            titel: "&nbsp;&nbsp;&nbsp;",
            zusatzFelder: [
              {key: "Tel.", value: "<a href='tel:06963015976'>069 6301-5976</a>"},
              {key: "Fax", value: "069 6301-83363"},
              {key: "E-Mail", value: "<a href='mailto:kinderschutzambulanz@ukffm.de' style='white-space:nowrap;'>kinderschutzambulanz@ukffm.de</a>"},
            ],
            betriebszeiten: "Mo.-Do. 08:00-17:00 Uhr<br>Fr. 08:00-16:30 Uhr",
          }],
      },
      {
        id: 14,
        titel: "Zentrum der Neurologie und Neurochirurgie",
        abteilungen: [
          {
            id: 69,
            titel: "Neurologie",
            terminvergabe: "<a href='tel:06963017468'>069 6301-7468</a>",
            aufnahme: "<a href='tel:06963013321'>069 6301-3321</a>",
            zusatzFelder: [
              {key: "E-Mail", value: "<a href='mailto:Neurologie@ukffm.de'>Neurologie@ukffm.de</a>"},
              {key: "Notaufnahme", value: "Tel. <a href='tel:069630183266'>069 6301-83266</a>"},
              {key: "", value: "Fax 069 6301-87046"},
              {key: "Casemanagement", value: "Tel. <a href='tel:06963015322'>069 6301-5322</a>"},
              {key: "", value: "Fax 069 6301-5323"},
              {key: "Sekretariat Klinikdirektor", value: "Tel. <a href='tel:06963015769'>069 6301-5769</a>"},
              {key: "", value: "Fax 069 6301-6842"},
              {key: "E-Mail Klinikdirektor", value: "<a href='mailto:grefkes-hermann@em.uni-frankfurt.de'>Grefkes-Hermann@em.uni-frankfurt.de</a>"},
              {key: "Sekretariat Oberärzte", value: "Tel. <a href='tel:06963016395'>069 6301-6395</a>"},
              {key: "", value: "Fax 069 6301-4498"},
            ],
            betriebszeiten: "Mo.-Fr. 09:00 15:00 Uhr"
          },
          {
            id: 70,
            titel: "Neurochirurgie",
            terminvergabe: "<a href='tel:06963015470'>069 6301-5470</a>",
            aufnahme: "<a href='tel:06963013320'>069 6301-3320</a>",
            zusatzFelder: [
              {key: "E-Mail", value: "<a href='mailto:Neurochirurgie@ukffm.de'>Neurochirurgie@ukffm.de</a>"},
            ],
            betriebszeiten: "Mo.-Fr. 08:00 bis 15:30 Uhr"
          },
          {
            id: 71,
            titel: "Dr. Senckenbergisches Institut für Neuroonkologie",
            zusatzFelder: [
              {key: "Ambulanz", value: "Tel. <a href='tel:069630187711'>069 6301-87711</a>"},
              {key: "", value: "Fax 069 6301-87713"},
            ],
            betriebszeiten: "Mo.-Fr. 08:00 bis 14:00 Uhr"
          },
          {
            id: 72,
            titel: "Epilepsie-und Schlafambulanz",
            terminvergabe: "<a href='tel:069630185065'>069 6301-85065</a>",
            betriebszeiten: "Mo.-Fr. 09:00 15:00 Uhr"
          },
          {
            id: 73,
            titel: "MS-und Bewegungsstörung Ambulanz",
            terminvergabe: "<a href='tel:06963013916'>069 6301-3916</a>",
            betriebszeiten: "Mo.-Do. 09:00 bis 16:00 Uhr"
          },
          {
            id: 74,
            titel: "Gamaknife",
            terminvergabe: "<a href='tel:06967735910'>069 67735910</a>"
          },
          {
            id: 75,
            titel: "Brain Imaging Center (BIC)",
            terminvergabe: "<a href='tel:069630183819'>069 6301-83819</a>"
          },
          {
            id: 76,
            titel: "Physiotherapie ZNN",
            terminvergabe: "<a href='tel:06963015545'>069 6301-5545</a> / <a href='tel:06963017345'>-7345</a>"
          }],
      },
      {
        id: 15,
        titel: "Zentrum der Zahn-, Mund- und Kieferheilkunde (Carolinum)",
        abteilungen: [
          {
            id: 77,
            titel: "Zentrale Aufnahme und Beratung (ZAB)",
            terminvergabe: "Tel. <a href='tel:06963014247'>069 6301-4247</a><br>Fax 069 6301-6741<br>E-Mail <a href='mailto:ZAB-carolinum@med.uni-frankfurt.de'>ZAB-carolinum@med.uni-frankfurt.de</a>",
            betriebszeiten: "Mo.-Fr. 09:00-11:00 Uhr sowie 14:30-17:00 Uhr",
          },
        ],
      },
      {
        id: 5463,
        titel: "Zentrum für psychische Gesundheit",
        kliniken: [
          {
            id: 17,
            titel: "Klinik für Psychiatrie, Psychosomatik und Psychotherapie des Kindes- und Jugendalters (Haus 92, Kinder- und Jugendpsychiatrie)",
            abteilungen: [
              {
                id: 79,
                titel: "Psychiatrie, Psychosomatik und Psychotherapie des Kindes- und Jugendalters",
                zusatzFelder: [
                  {key: "Institutsambulanz", value: "<a href='tel:06963015920'>069 6301-5920</a>"},
                  {key: "Privatambulanz", value: "<a href='tel:06963015408'>069 6301-5408</a>"},
                  {key: "Stationäre Anmeldungen", value: "<a href='tel:06963015848'>069 6301-5848</a>"},
                  {key: "Oberarzt Sekretariat", value: "<a href='tel:06963017050'>069 6301-7050</a>"},
                  {key: "Zentrale Faxnummer", value: "<a href='tel:06963015843'>069 6301-5843</a>"},
                  {key: "Notfälle (akute Eigen- und Fremd&shy;gefährdung/außerhalb der Betriebszeiten)", value: "<a href='tel:06963015923'>069 6301-5923</a>"},
                ],
                betriebszeiten: "Mo.-Fr. 08:00 bis 16:00 Uhr"
              },
              {
                id: 80,
                titel: "Autismus-Therapie-Zentrum Haus 92A",
                zusatzFelder: [
                  {key: "Therapieanfragen", value: "<a href='tel:069630186364'>069 6301-86364</a>"},
                ],
              }
            ],
          },
          {
            id: 16,
            titel: "Klinik für Psychiatrie, Psychosomatik und Psychotherapie (Haus 93, Erwachsenenpsychiatrie)",
            footerFields: [
              "Weitere Informationen: <a href='https://www.psychiatrie.uni-frankfurt.de'>www.psychiatrie.uni-frankfurt.de</a>"
            ],
            abteilungen: [
              {
                id: 76748991,
                titel: "Psychiatrische Institutsambulanz (PIA)",
                zusatzFelder: [
                  {key: "Terminvergabe und stationäre Aufnahme", value: "<span style='white-space:nowrap;'>Tel. <a href='tel:06963015079'>069 6301-5079</a><br>Fax 069 6301-7087<br>E-Mail <a href='mailto:psychiatrie@ukffm.de'>psychiatrie@ukffm.de</a></span>"},
                ],
                sonstiges: "Wenn möglich, schicken Sie bitte ein Fax oder eine E-Mail mit Informationen zu Ihrem Anliegen und einer Rückrufnummer",
              },
              {
                id: 76748992,
                titel: "Casemanagement (CM)",
                zusatzFelder: [
                  {key: "Verlegungen im Rahmen der Pflichtversorgung der Stadt Frankfurt, sowie für die Wartelisten der Stationen:"},
                  {key: "<span style='font-weight:normal'>Tel. <a href='tel:069630186657'>069 6301-86657</a><br>Fax 069 6301-3885<br>E-Mail <a href='mailto:cm-psychiatrie@ukffm.de'>cm-psychiatrie@ukffm.de</a></span>"},
                ],
              },
              {
                id: 76748994,
                titel: "Notfallnummer",
                zusatzFelder: [
                  {key: "<span style='font-weight:normal'>Zu den Betriebszeiten</span>", value: "Tel. <a href='tel:06963014806'>069 6301-4806</a>"},
                ],
              },
              {
                id: 767489935,
                titel: "Betriebszeiten",
                sonstiges: "Mo.-Fr. 08:00 bis 16:00 Uhr",
              },
            ],
          },
        ],
      },
      {
        id: 18,
        titel: "Dr. Senckenbergisches Institut für Pathologie",
        emails: [
          {titel: "", adresse: "pathologie@ukffm.de"}
        ],
        abteilungen: [
          {
            id: 18467847,
            titel: 'Befundauskunft Pathologie',
            zusatzFelder: [
              {key: "E-Mail", value: "<a href='mailto:Befundauskunft.Pathologie@ukffm.de'>Befundauskunft.Pathologie@ukffm.de</a>"},
              {key: "", value: "Anja Hameier-Jakob, Claudia Seiwerth"},
              {key: "Tel.", value: "<a href='tel:06963015046'>069 6301-5046</a>"},
              {key: "Fax", value: "069 6301-5456"},
            ],
          },
          {
            id: 18245629,
            titel: 'Information für Bestatter',
            zusatzFelder: [
              {key: "Öffnungszeiten", value: "Mo.-Mi. 10:00 – 15:00 Uhr<br>Do. 10:00 – 14:30 Uhr<br>Fr. 10:00 – 14:00 Uhr"},
              {key: "Hr. Vittorio Collu", value: "<a href='tel:015117190945'>0151-171 90 945</a>"},
              {key: "Hr. Mehmet Akkaya", value: "<a href='tel:015117192265'>0151-171 92 265</a>"},
            ],
          },
          {
            id: 1803565683,
            titel: 'Standesamt',
            zusatzFelder: [
              {key: "Anfahrt Haus 13B, Raum B12"},
              {key: "Öffnungszeiten", value: "Mo.-Fr. 09:00 bis 13:00 Uhr"},
            ],
          },
        ],
      },
    ],
  },

  mutations: {},

  actions: {},

  getters: {},

  modules: {}
})
